import _ from 'lodash'
import { setFilter } from 'src/redux/slices/eLearning/learningPath/list'

export const handleChangeSlider = (value) => (dispatch) => {
  dispatch(setFilter({ key: 'pathHourFrom', value: value[0] }))
  dispatch(setFilter({ key: 'pathHourTo', value: value[1] }))
}

export const handleChangePeriod = (formattedDate) => (dispatch) => {
  dispatch(setFilter({ key: 'startDate', value: formattedDate.startDate }))
  dispatch(setFilter({ key: 'finishDate', value: formattedDate.finishDate }))
}

export const handleResetPeriod = () => (dispatch) => {
  dispatch(setFilter({ key: 'startDate', value: '' }))
  dispatch(setFilter({ key: 'finishDate', value: '' }))
}

export const handleChangeSort = (e) => (dispatch) => {
  const name = _.get(e.target, 'name', '')
  const value = _.get(e.target, 'value', '')
  dispatch(setFilter({ key: name, value }))
}
